
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/parking/booking/modify/confirmation",
      function () {
        return require("private-next-pages/[locale]/parking/booking/modify/confirmation.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/parking/booking/modify/confirmation"])
      });
    }
  